import logoDesaprobar from '../assets/logoDesaprobar.png';
import logoAprobar from '../assets/logoAprobar.png';

export const BooleanToggleActions = ({
    value,
    onTrue,
    onFalse,
    loading = false,
    trueProps = {},
    falseProps = {}
}) => {
    return (
        <>
            {(!value || value === null) && (
                <img
                    className={`cursor-pointer img-blanco-mobile 
                        ${loading ? "opacity-50 pointer-events-none" : ""}`}
                    src={logoAprobar}
                    alt="Approve"
                    onClick={onTrue}
                    {...trueProps}
                />
            )}

            {(value || value === null) && (
                <img
                    className={`${value ? '' : 'ms-3'} cursor-pointer img-blanco-mobile
                        ${loading ? "opacity-50 pointer-events-none" : ""}`}
                    src={logoDesaprobar}
                    alt="Disapprove"
                    onClick={onFalse}
                    {...falseProps}
                />
            )}
        </>
    );
};